<div
  class="task-list-table"
  infiniteScroll
  [scrollWindow]="false"
  [alwaysCallback]="true"
  (scrolled)="onScroll()"
  #payrollTaskContainer>
  <table id="payroll-tasks-table" class="table table-sm table-fixed" *ngIf="tasks">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>
          <div
            class="sort mb-2"
            (click)="sortTasksBy($event, 'PayrollInputMethod', payrollTaskContainer)">
            Method
          </div>
          <div ngbDropdown container="body">
            <button
              class="form-control"
              id="inputMethodFilter"
              ngbDropdownToggle
              cpGTagEvent
              [params]="{ event_label: 'csr_home_payroll_task_method_filter' }"
              style="text-align: left; padding-left: 10px">
              <div style="overflow-x: hidden; display: inline-flex; max-width: 125px">
                {{ getMethodFilterText() }}
              </div>
            </button>
            <div ngbDropdownMenu aria-labelledby="inputMethodFilter">
              <div
                *ngFor="let method of payrollInputMethods | enumToKeyValue; let i = index"
                class="px-3">
                <input
                  type="checkbox"
                  id="{{ method.key + '_chk' }}"
                  value="true"
                  class="small"
                  [(ngModel)]="payrollMethodFilters[method.value]"
                  (ngModelChange)="filterBy(payrollTaskContainer)" />
                <label for="{{ method.key + '_chk' }}"><span></span> &nbsp;{{ method.key }} </label>
                <br />
              </div>
            </div>
          </div>
        </th>
        <th>
          <span class="sort" (click)="sortTasksBy($event, 'ClientCode', payrollTaskContainer)"
            >Client Id</span
          ><br />
          <input
            [(ngModel)]="searchConfig.ClientId"
            (ngModelChange)="filterBy(payrollTaskContainer, true)"
            class="form-control mb-0 mt-2"
            placeholder="Filter..." />
        </th>
        <th>
          <span class="sort" (click)="sortTasksBy($event, 'ClientName', payrollTaskContainer)"
            >Client Name</span
          ><br />
          <input
            [(ngModel)]="searchConfig.ClientName"
            (ngModelChange)="filterBy(payrollTaskContainer, true)"
            class="form-control mb-0 mt-2"
            placeholder="Filter..." />
        </th>
        <th>
          <span class="sort" (click)="sortTasksBy($event, 'Type', payrollTaskContainer)"
            >Task Type</span
          >
          <select
            [(ngModel)]="searchConfig.TaskTypes[0]"
            (ngModelChange)="filterBy(payrollTaskContainer)"
            class="form-control mb-0 mt-2">
            <option style="color: lightgray" [ngValue]="undefined">
              {{ searchConfig.TaskTypes[0] ? '' : 'Filter...' }}
            </option>
            <ng-container *ngFor="let type of taskTypes">
              <option *ngIf="isPayrollTaskType(type.Name)" value="{{ type.Name }}">
                {{ type.Name }}
              </option>
            </ng-container>
          </select>
        </th>
        <th>
          <div class="sort mb-2" (click)="sortTasksBy($event, 'Status', payrollTaskContainer)">
            Status
          </div>
          <div ngbDropdown container="body">
            <button
              class="form-control"
              id="statusFilter"
              ngbDropdownToggle
              cpGTagEvent
              [params]="{ event_label: 'csr_home_payroll_task_status_filter' }"
              style="text-align: left; padding-left: 10px">
              <div style="overflow-x: hidden; display: inline-flex; max-width: 125px">
                {{ getStatusFilterText() }}
              </div>
            </button>
            <div ngbDropdownMenu aria-labelledby="statusFilter">
              <div *ngFor="let status of taskStatuses | enumToKeyValue; let i = index" class="px-3">
                <input
                  type="checkbox"
                  id="{{ status.key + '_chk' }}"
                  value="true"
                  class="small"
                  [(ngModel)]="taskStatusFilters[status.value]"
                  (ngModelChange)="filterBy(payrollTaskContainer)" />
                <label for="{{ status.key + '_chk' }}"
                  ><span></span> &nbsp;{{ status.key | camelToTitle }}
                </label>
                <br />
              </div>
            </div>
          </div>
        </th>
        <th>
          <span class="sort" (click)="sortTasksBy($event, 'Priority', payrollTaskContainer)"
            >Priority</span
          >
          <select
            [(ngModel)]="searchConfig.Priority"
            (ngModelChange)="filterBy(payrollTaskContainer)"
            class="form-control mb-0 mt-2">
            <option style="color: lightgray" [ngValue]="undefined">
              {{ searchConfig.Priority ? '' : 'Filter...' }}
            </option>
            <option value="1">Low</option>
            <option value="2">Medium</option>
            <option value="3">High</option>
            <option value="4">Urgent</option>
          </select>
        </th>
        <th>
          <span class="sort" (click)="sortTasksBy($event, 'PayrollFrequency', payrollTaskContainer)"
            >Frequency</span
          ><br />
          <select
            [(ngModel)]="searchConfig.PayrollFrequency"
            (ngModelChange)="filterBy(payrollTaskContainer)"
            class="form-control mb-0 mt-2">
            <option style="color: lightgray" [ngValue]="undefined">
              {{ searchConfig.PayrollFrequency ? '' : 'Filter...' }}
            </option>
            <option
              *ngFor="let frequency of payrollFrequencies | enumToKeyValue"
              [value]="frequency.value">
              {{ frequency.key | camelToTitle }}
            </option>
          </select>
        </th>
        <th>
          <span class="sort" (click)="sortTasksBy($event, 'PayDate', payrollTaskContainer)"
            >Pay Date</span
          >
          <input
            [(ngModel)]="searchConfig.PayDate"
            (ngModelChange)="filterBy(payrollTaskContainer, true)"
            class="form-control mb-0 mt-2"
            placeholder="Filter..." />
        </th>
        <th *hasMinRole="'CSR1'">
          <span>CSR</span>
          <select
            class="form-control mb-0 mt-2"
            [(ngModel)]="searchConfig.Assignees"
            (ngModelChange)="filterBy(payrollTaskContainer)">
            <option></option>
            <option *ngFor="let usr of viewMembers" value="{{ usr.userName }}">
              {{ usr.firstName }} {{ usr.lastName }}
            </option>
          </select>
        </th>
        <th>
          <span class="sort" (click)="sortTasksBy($event, 'DueBy', payrollTaskContainer)"
            >Due Date</span
          >
          <input
            [(ngModel)]="searchConfig.DueDateLike"
            (ngModelChange)="filterBy(payrollTaskContainer, true)"
            class="form-control mb-0 mt-2"
            placeholder="Filter..." />
        </th>
        <th>
          <span class="sort" (click)="sortTasksBy($event, 'PayrollStatus', payrollTaskContainer)"
            >Payroll Status</span
          >
          <div ngbDropdown container="body" class="mt-2">
            <button
              class="form-control"
              id="payrollStatusFilter"
              ngbDropdownToggle
              cpGTagEvent
              [params]="{ event_label: 'csr_home_payroll_tasks_payroll_status_filter' }"
              style="text-align: left; padding-left: 10px">
              <div style="overflow-x: hidden; display: inline-flex; max-width: 125px">
                {{ getPayrollStatusFilterText() }}
              </div>
            </button>
            <div ngbDropdownMenu aria-labelledby="payrollStatusFilter">
              <div
                *ngFor="let status of agilePayrollStatuses | enumToKeyValue; let i = index"
                class="px-3">
                <input
                  type="checkbox"
                  id="{{ status.key + '_chk' }}"
                  value="true"
                  class="small"
                  [(ngModel)]="payrollStatusFilters[status.key]"
                  (ngModelChange)="filterBy(payrollTaskContainer)" />
                <label for="{{ status.key + '_chk' }}"><span></span> &nbsp;{{ status.key }} </label>
                <br />
              </div>
            </div>
          </div>
        </th>
        <th>
          <span class="sort" (click)="sortTasksBy($event, 'ContactName', payrollTaskContainer)"
            >Contact Name</span
          >
          <input
            [(ngModel)]="searchConfig.ContactName"
            (ngModelChange)="filterBy(payrollTaskContainer, true)"
            class="form-control mb-0 mt-2"
            placeholder="Filter..." />
        </th>
        <th>
          <span class="sort" (click)="sortTasksBy($event, 'ContactPhone', payrollTaskContainer)"
            >Contact Phone</span
          >
          <input
            [(ngModel)]="searchConfig.ContactPhone"
            (ngModelChange)="filterBy(payrollTaskContainer, true)"
            class="form-control mb-0 mt-2"
            placeholder="Filter..." />
        </th>
        <th>
          <span class="sort" (click)="sortTasksBy($event, 'ContactEmail', payrollTaskContainer)"
            >Contact Email</span
          >
          <input
            [(ngModel)]="searchConfig.ContactEmail"
            (ngModelChange)="filterBy(payrollTaskContainer, true)"
            class="form-control mb-0 mt-2"
            placeholder="Filter..." />
        </th>
        <th class="align-baseline">Go To<br />Notes</th>
        <th class="align-baseline">Go To<br />Payroll</th>
      </tr>
    </thead>
    <tbody *ngFor="let task of tasks">
      <tr [ngClass]="task.IsRead ? 'read-task' : 'unread-task'">
        <td (click)="task.SubTaskCount ? toggleExpandedTasks(task.Id) : ''">
          <i
            *ngIf="task.SubTaskCount"
            class="fas"
            [ngClass]="expandedTasks[task.Id] ? 'fa-chevron-down' : 'fa-chevron-right'">
          </i>
        </td>
        <td *hasMinRole="'CSR1'">
          <input
            type="checkbox"
            class="small"
            [(ngModel)]="selTasks[task.Id]"
            id="{{ 'task-' + task.Id }}"
            (ngModelChange)="toggleSelectedTasks()" />
          <label for="{{ 'task-' + task.Id }}"><span></span></label>
        </td>
        <td (click)="editTask(task)">
          {{ task.PayrollInputMethod }}
        </td>
        <td (click)="editTask(task)">
          {{ task.ClientCode }}
        </td>
        <td (click)="editTask(task)">
          {{ task.ClientName }}&nbsp;
          <span
            *ngIf="task.SubTaskCount"
            style="
              padding: 3px 8px;
              background-color: white;
              border: 1px solid grey;
              border-radius: 19px;
              font-size: small;
              font-weight: bold;
            ">
            {{ task.SubTaskCount }}
          </span>
        </td>
        <td (click)="editTask(task)">
          {{ task.Type }}
        </td>
        <td (click)="editTask(task)">
          <span
            [ngClass]="
              task.Status === taskStatuses.Resolved || task.Status === taskStatuses.Closed
                ? 'cp-green'
                : ''
            ">
            {{ taskStatuses[task.Status] | camelToTitle }}
          </span>
        </td>
        <td (click)="editTask(task)">
          <div class="task-priority-bubble" [ngClass]="taskPriorities[task.Priority].toLowerCase()">
            {{ taskPriorities[task.Priority].toUpperCase() }}
          </div>
        </td>
        <td (click)="editTask(task)">
          {{ task.PayFrequency != 0 ? task.PayFrequency : '' }}
        </td>
        <td (click)="editTask(task)">
          {{ getDayOfWeek(task.PayDate) }}
          <br />
          {{ task.PayDate | date: 'MM/dd/yyyy' }}
        </td>
        <td *hasMinRole="'CSR1'" (click)="editTask(task)">
          {{ getTaskAssigneeName(task.AssigneeAgileId) }}
        </td>
        <td (click)="editTask(task)">
          {{ task.DueDate | date: 'MM/dd/yyyy' }}
        </td>
        <td (click)="editTask(task)">
          {{ task.PayrollStatus }}
        </td>
        <td (click)="editTask(task)">
          {{ task.ContactName }}
        </td>
        <!-- if no phone, cell click should open task -->
        <td *ngIf="!task.ContactPhone" (click)="editTask(task)"></td>
        <td *ngIf="task.ContactPhone">
          <a href="{{ 'tel:' + task.ContactPhone }}">{{ task.ContactPhone }}</a>
        </td>
        <!-- if no email, cell click should open task -->
        <td *ngIf="!task.ContactEmail" (click)="editTask(task)"></td>
        <td *ngIf="task.ContactEmail">
          <a href="{{ 'mailto:' + task.ContactEmail }}">{{ task.ContactEmail }}</a>
        </td>
        <td class="text-center" title="Go To Client Notes">
          <a routerLink="/client/{{ task.ClientCode }}/notes" target="_blank">
            <i class="far fa-sticky-note"></i>
          </a>
        </td>
        <td class="text-center" title="Go to payroll">
          <a (click)="goToTask(task)" target="_blank" data-testid="goto-task-link">
            <i class="fas fa-external-link-alt"></i>
          </a>
        </td>
      </tr>
      <tr *ngIf="expandedTasks[task.Id]" class="expandable-row" [@inOutAnimation]>
        <td></td>
        <td></td>
        <td
          [attr.colspan]="
            aclService.HasMinimumRoleByName(authService.getCurrentUserId(), 'CSR1') ? 9 : 7
          ">
          <div class="mb-3"><strong>Task Subtasks</strong></div>
          <div *ngIf="expandedTasks[task.Id][subTaskGroups.BeforePayroll]" class="mb-3">
            <strong><small>Before Payroll</small></strong>
            <div
              *ngFor="let subTask of expandedTasks[task.Id][subTaskGroups.BeforePayroll]"
              class="mt-2">
              <input
                type="checkbox"
                id="{{ 'subtaskrow' + task.Id + subTask.SubTaskId }}"
                value="true"
                class="small"
                [(ngModel)]="subTask.IsComplete"
                (click)="toggleSubTaskCompletion(task.Id, subTask.SubTaskId, subTask.IsComplete)"
                title="Mark Task as Completed" />
              <label for="{{ 'subtaskrow' + task.Id + subTask.SubTaskId }}"
                ><span></span>
                <small>&nbsp;{{ subTask.Description }}</small>
              </label>
            </div>
          </div>
          <div *ngIf="expandedTasks[task.Id][subTaskGroups.AfterPayroll]" class="mb-3">
            <strong><small>After Payroll</small></strong>
            <div
              *ngFor="let subTask of expandedTasks[task.Id][subTaskGroups.AfterPayroll]"
              class="mt-2">
              <input
                type="checkbox"
                id="{{ 'subtaskrow' + task.Id + subTask.SubTaskId }}"
                value="true"
                class="small"
                [(ngModel)]="subTask.IsComplete"
                (click)="toggleSubTaskCompletion(task.Id, subTask.SubTaskId, subTask.IsComplete)"
                title="Mark Task as Completed" />
              <label for="{{ 'subtaskrow' + task.Id + subTask.SubTaskId }}"
                ><span></span>
                <small>&nbsp;{{ subTask.Description }}</small>
              </label>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div *ngIf="tasks && tasks.length === 0">
  <em>No tasks right now...</em>
</div>
